<template>
  <div v-if="showFilter" class="mp-edition-filter">
    <div class="row">
    <div class="col-12 col-sm-6">
      <select v-model="year" class="form-select" @change="search">
        <option selected value="">{{ translations.allYears }}</option>
        <option v-for="year in years" :value="year">{{ year }}</option>
      </select>
    </div>
    <div class="col-12 col-sm-6">
      <select v-model="month" :disabled="year === ''" class="form-select" @change="search">
        <option selected value="">{{ translations.allIssues }}</option>
        <option v-for="month in 8" :value="month">{{ month }}</option>
      </select>
    </div>
    </div>
  </div>
  <div class="row items app mt-5" id="mp-edition-viewer">
    <article v-for="item in results.data" :key="item.id" class="col-6 col-sm-3 col-md-3 mb-4">
      <a :href="viewerUrl + '?rid=' + item.id">
        <div class="item">
          <div class="box shadow">
            <img :alt="item.Name" :src="getImagePath(item.id)" class="img-fluid">
          </div>
            <div class="label mt-2 text-center">
              <strong v-if="translations.record">{{ translations.record }}:</strong> {{ item.name }}
            </div>
          
        </div>
      </a>
    </article>

  </div>
<!--  <div v-if="showPaging" class="paging">-->
    <nav aria-label="Page navigation">
      <md-pager :pageNumber="pageNumber" :total-pages="totalPages" @update="changePage"></md-pager>
    </nav>
<!--  </div>-->
</template>

<script>
import axios from 'axios';
import MdPager from '../Components/Pager.vue';

export default {
  components: {
    MdPager
  },
  props: {
    pageSize: Number,
    showFilter: Boolean,
    showPaging: Boolean,
    categoryId: {
      type: String,
      default: ''
    },
    page: Number,
    searchUrl: String,
    viewerUrl: String
  },
  data() {
    return {
      year: '',
      month: '',
      query: '',
      totalPages: 0,
      limit: 50,
      offset: 0,
      results: {
        data: [],
        total: 0
      }
    }
  },
  mounted() {
    this.limit = this.pageSize;
    this.offset = (this.page - 1) * this.limit;
    this.search();
  },
  methods: {
    search() {
      let self = this;
      let from = self.getFrom();
      let to = self.getTo();
      axios.get(`/umbraco/md/multipaper/Search?from=${from}&to=${to}&limit=${self.limit}&offset=${self.offset}`).then(res => {
        self.results = res.data;
        self.totalPages = Math.ceil(self.results.total / self.limit);
      });
    },
    getImagePath(recordId) {
      return `/umbraco/md/multipaper/GetJpgByPageNumber?recordId=${recordId}&pageNumber=1`;
    },
    changePage(pageNumber) {
      this.offset = (pageNumber - 1) * this.limit;
      this.search();
    },
    getTo() {
      if (this.year !== '' && this.month !== '') {
        let daysInMonth = new Date(this.year, this.month, 0).getDate();
        return `${this.year}-${this.month}-${daysInMonth}T00:00:00Z`;
      }
      if (this.year !== '' && this.month === '') {
        return `${this.year}-12-31T00:00:00Z`;
      }
      return null;
    },
    getFrom() {
      if (this.year !== '' && this.month !== '') {
        return `${this.year}-${this.month}-01T00:00:00Z`;
      }
      if (this.year !== '' && this.month === '') {
        return `${this.year}-01-01T00:00:00Z`;
      }
      return null;
    }
  },
  computed: {
    translations() {
      return multiPaper.listTranslations;
    },
    pageNumber() {
      if (this.offset === 0) {
        return 1;
      }
      return this.offset / this.limit + 1;
    },
    years() {
      let years = [];
      let actualYear = new Date().getFullYear();
      for (let year = actualYear; year >= 2004; year--) {
        years.push(year);
      }
      return years;
    }
  }
}
</script>
